//main
import Swiper from 'swiper/bundle'

// shuffle programs
const shuffleDivs = () => {
    const selector = `#mainPrograms .swiper-slide`;
    var list = document.querySelectorAll(selector);
    for (let i in list) {
        if (typeof list[i].nodeType == 'undefined') continue;
        let sibling = list[i];
        while (true) {
            sibling = list[Math.floor(Math.random() * list.length)];
            if ((sibling != list[i]) && (typeof sibling.nodeType != 'undefined')) break;
        }
        sibling.insertAdjacentHTML('beforebegin', list[i].outerHTML);
        list[i].insertAdjacentHTML('beforebegin', sibling.outerHTML);
        sibling.remove();
        list[i].remove();
        list = document.querySelectorAll(selector);
    }
}
shuffleDivs();

//programs resposive
 var swiper = new Swiper(".prSliderUni", {
     spaceBetween: 13,
     loop: false,
     freeMode: false,
     simulateTouch:false, 
     slidesPerView: "auto",
     navigation: {
         nextEl: ".swiper-button-next",
         prevEl: ".swiper-button-prev",
     },
     pagination: {
         el: ".swiper-pagination",
         clickable: true,
     },
     breakpoints: {
         320: {
           slidesPerView: 1,
           spaceBetween: 0,
          freeMode: true,
          simulateTouch:true, 
         },
         640: {
           slidesPerView: 2,
           spaceBetween: 10,
         },
         720: {
           slidesPerView: 3,
           spaceBetween: 13,
            freeMode: true,
           simulateTouch:true, 
         },
         920: {
           slidesPerView: "auto",
           spaceBetween: 0,
           freeMode: false,
           simulateTouch:false, 
         },
       },
 
 });
